import axios from '@/services/axios-auth-wrapper';

export default {
    getDefaultMetricWeights: () => {
        return axios.get(url + 'metric');
    },
    getDefaultPillarWeights: () => {
        return axios.get(url + 'pillar');
    },
    updateDefaultMetricWeights: (metricWeights) => {
        return axios.post(url + 'metric', metricWeights);
    },
    updateDefaultPillarWeights: (pillarWeights) => {
        return axios.post(url + 'pillar', pillarWeights);
    }
};

const url = process.env.VUE_APP_CONVERSABILITY_API_URL + '/api/weights/';
